import React, { Component } from 'react';

export default class Navigation extends Component {
	constructor(props) {
		super(props);
		this.styles = {
			navBar: {
				backgroundColor: '#222',
			},
		};
	}
	render() {
		return (
		    <nav id="mainNav" style={this.styles.navBar} className="navbar navbar-default navbar-custom navbar-fixed-top affix-top">
		        <div className="container">
		            <div className="navbar-header page-scroll">
		                <button type="button" className="navbar-toggle" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1">
		                    <span className="sr-only">Toggle navigation</span> Menu <i className="fa fa-bars"></i>
		                </button>
		                <a className="navbar-brand page-scroll" href="#page-top">justsang</a>
		            </div>

		            <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
		                <ul className="nav navbar-nav navbar-right">
		                    <li className="hidden">
		                        <a href="#page-top"></a>
		                    </li>
		                    <li>
		                        <a className="page-scroll" href="#passion">Passion</a>
		                    </li>
		                    <li>
		                        <a className="page-scroll" href="#about">About</a>
		                    </li>
							<li>
		                        <a className="page-scroll" href="#portfolio">Portfolio</a>
		                    </li>
		                    {/* <li>
		                        <a className="page-scroll" href="#contact">Contact</a>
		                    </li> */}
		                </ul>
		            </div>
		        </div>
		    </nav>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Navigation.jsx